import React, { useState, useMemo, useCallback } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import MessagingPopup from "./MessagingPopup";
import AddNewMessage from "./AddNewMessage";
import { getFormatedNumber } from "../Services/appService";
import { getCurrentUser } from "../app/store/auth";
import { useLoadPortalAppMessagesQuery } from "../app/store/candidateApiSlice";

const APP_MESSAGES_STYLES = {
  modalContent: {
    borderRadius: "0px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  modalFooter: {
    padding: "16px 22px 20px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },

  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "21px",
    boxShadow: "none",
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: 0,
    fontWeight: "normal"
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  sectionCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    overflow: "hidden",
    marginBottom: "16px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    padding: "16px 18px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
  },
  toolbarTitle: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#0f172a",
    margin: 0,
  },
  toolbarSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  addButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  table: {
    margin: 0,
    minWidth: "820px",
  },
  tableHeader: {
    background: "#f8fbff",
    borderBottom: "1px solid #e2e8f0",
  },
  headerCell: {
    fontSize: "11px",
    fontWeight: 600,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    padding: "14px 18px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
  },
  rowCell: {
    fontSize: "13px",
    color: "#334155",
    padding: "16px 18px",
    verticalAlign: "middle",
    borderTop: "1px solid rgba(241, 245, 249, 1)",
  },
  indexBadge: {
    width: "28px",
    height: "28px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(79, 70, 229, 0.08)",
    color: "#4338ca",
    fontSize: "12px",
    fontWeight: 600,
  },
  officerName: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "4px",
  },
  officerMeta: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.55,
  },
  viewButton: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "8px 14px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  countBadge: {
    minWidth: "20px",
    height: "20px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 6px",
    fontSize: "11px",
    fontWeight: 600,
  },
  unreadBadge: {
    background: "#fee2e2",
    color: "#b91c1c",
    border: "1px solid rgba(254, 202, 202, 1)",
  },
  readBadge: {
    background: "#dcfce7",
    color: "#166534",
    border: "1px solid rgba(187, 247, 208, 1)",
  },
  emptyState: {
    padding: "38px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

export default function AppMessages(props) {
  const { workflowId, currentApp, msgShowHide, handleMsgShowHide } = props;

  const [addMsgShowHide, setAddMsgShowHide] = useState(false);
  const [msgObj, setMsgObj] = useState("");
  const [showHide, setShowHide] = useState(false);

  const currentUser = useMemo(() => getCurrentUser(), []);

  const userId = useMemo(() => {
    if (!currentUser) return null;
    return currentUser.type === "partner" ? currentUser.linkUser : currentUser.id;
  }, [currentUser]);

  // RTK Query query hook
  const { data: appMessagesData, refetch: refetchAppMessages } = useLoadPortalAppMessagesQuery(
    { wfId: workflowId, userId },
    { skip: !msgShowHide || !workflowId || !userId }
  );

  const appMessages = useMemo(() => {
    if (!appMessagesData) return [];
    return appMessagesData.filter((x) => x.ciid === currentApp?.ciid);
  }, [appMessagesData, currentApp?.ciid]);

  const wfTask = useMemo(() => [currentApp], [currentApp]);

  const handleAddNewMessagePopup = useCallback((app) => {
    if (app === "save") {
      setAddMsgShowHide(false);
      refetchAppMessages();
    }
    else {
      setAddMsgShowHide((prev) => !prev);
    }
  }, [refetchAppMessages]);

  const handleMessagePopup = useCallback((obj) => {
    setShowHide((prev) => !prev);
    setMsgObj(obj);
  }, []);

  const handleSendMessage = useCallback(() => {
    if (workflowId > 0) {
      refetchAppMessages();
    }
  }, [workflowId, refetchAppMessages]);

  return (
    <React.Fragment>
      <Modal
        show={msgShowHide}
        size="xl"
        centered
        onHide={handleMsgShowHide}
        dialogClassName="app-messages-modal-dialog"
        contentClassName="app-messages-modal-content"
      >
        <style>{`
          .app-messages-modal-dialog {
            max-width: ${APP_MESSAGES_STYLES.modalDialog.maxWidth};
          }
          .app-messages-modal-content {
            border-radius: ${APP_MESSAGES_STYLES.modalContent.borderRadius};
            overflow: ${APP_MESSAGES_STYLES.modalContent.overflow};
            border: ${APP_MESSAGES_STYLES.modalContent.border};
            box-shadow: ${APP_MESSAGES_STYLES.modalContent.boxShadow};
          }
          .app-messages-table tbody tr:hover {
            background-color: #fbfdff;
          }
        `}</style>
        <Modal.Header style={APP_MESSAGES_STYLES.modalHeader}>
          <div style={APP_MESSAGES_STYLES.headerContent}>
            <Modal.Title as="div" style={APP_MESSAGES_STYLES.titleWrap}>
              <div style={APP_MESSAGES_STYLES.headerIcon}>
                <i className="fa fa-comments-o" aria-hidden="true"></i>
              </div>
              <div>
                <div style={APP_MESSAGES_STYLES.title}>Messages</div>
                <div style={APP_MESSAGES_STYLES.subtitle}>
                  Review application conversations and send a new message to the review team.
                </div>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={APP_MESSAGES_STYLES.closeButton}
              onClick={handleMsgShowHide}
              aria-label="Close messages popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={APP_MESSAGES_STYLES.modalBody}>
          <div style={APP_MESSAGES_STYLES.helperCard}>
            <div style={APP_MESSAGES_STYLES.helperTitle}>Message center</div>
            <p style={APP_MESSAGES_STYLES.helperText}>
              Use this space to review conversation threads for this application. Unread and read counters show activity inside each message thread.
            </p>
          </div>

          <div style={APP_MESSAGES_STYLES.sectionCard}>
            <div style={APP_MESSAGES_STYLES.toolbar}>
              <div>
                <div style={APP_MESSAGES_STYLES.toolbarTitle}>Application Messages</div>
                <div style={APP_MESSAGES_STYLES.toolbarSubtitle}>
                  {appMessages.length} thread{appMessages.length === 1 ? "" : "s"} available
                </div>
              </div>
              <button
                className="btn"
                style={APP_MESSAGES_STYLES.addButton}
                onClick={() => handleAddNewMessagePopup("")}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
                Add Message
              </button>
            </div>

            <div className="table-responsive" style={{ maxHeight: 420, overflow: "auto" }}>
              <table className="table align-items-center table-hover app-messages-table" style={APP_MESSAGES_STYLES.table}>
                <thead style={APP_MESSAGES_STYLES.tableHeader}>
                  <tr>
                    <th style={APP_MESSAGES_STYLES.headerCell}>#</th>
                    <th style={APP_MESSAGES_STYLES.headerCell}>Date & Time</th>
                    <th style={APP_MESSAGES_STYLES.headerCell}>Review Officer</th>
                    <th style={APP_MESSAGES_STYLES.headerCell}>Messages</th>
                  </tr>
                </thead>
                <tbody>
                  {appMessages.length > 0 ? appMessages.map((item, key) => (
                    <tr key={item.id || key}>
                      <td style={APP_MESSAGES_STYLES.rowCell}>
                        <span style={APP_MESSAGES_STYLES.indexBadge}>{key + 1}</span>
                      </td>
                      <td style={APP_MESSAGES_STYLES.rowCell}>
                        <div className="font-weight-bold">
                          <Moment format="MMM Do YYYY">
                            {item.addedDateTime}
                          </Moment>
                        </div>
                        <div className="small text-muted">
                          <Moment format="h:mm a">
                            {item.addedDateTime}
                          </Moment>
                        </div>
                      </td>
                      <td style={APP_MESSAGES_STYLES.rowCell}>
                        <div style={APP_MESSAGES_STYLES.officerName}>
                          {item.role === "Super Admin"
                            ? item.sender
                            : item.receiver}
                        </div>
                        <div style={APP_MESSAGES_STYLES.officerMeta}>
                          <div>{item.role}</div>
                          <div>{item.email}</div>
                          {item.contact && <div>{getFormatedNumber(item.contact)}</div>}
                        </div>
                      </td>

                      <td style={APP_MESSAGES_STYLES.rowCell}>
                        <button
                          type="button"
                          className="btn"
                          style={APP_MESSAGES_STYLES.viewButton}
                          onClick={() => handleMessagePopup(item)}
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                          View Thread
                          {item.unreadCount > 0 &&
                            <span style={{ ...APP_MESSAGES_STYLES.countBadge, ...APP_MESSAGES_STYLES.unreadBadge }}>
                              {item.unreadCount}
                            </span>}
                          {item.readCount > 0 && item.unreadCount === 0 &&
                            <span style={{ ...APP_MESSAGES_STYLES.countBadge, ...APP_MESSAGES_STYLES.readBadge }}>
                              {item.readCount}
                            </span>}
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="4" style={APP_MESSAGES_STYLES.emptyState}>
                        <i className="fa fa-comments-o fa-3x mb-3 d-block opacity-2"></i>
                        No messages found for this application.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>


        </Modal.Body>
        <Modal.Footer style={APP_MESSAGES_STYLES.modalFooter}>
          <div style={APP_MESSAGES_STYLES.footerActions}>
            <button
              type="button"
              style={APP_MESSAGES_STYLES.cancelButton}
              onClick={handleMsgShowHide}
            >
              <i className="fa fa-times" aria-hidden="true"></i>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <AddNewMessage
        addMsgShowHide={addMsgShowHide}
        handleAddMsgModalShowHide={handleAddNewMessagePopup}
        runningApplication={wfTask}
      ></AddNewMessage>
      <MessagingPopup
        msgShowHide={showHide}
        message={msgObj}
        handleMsgModalShowHide={handleMessagePopup}
        handleSendMessage={handleSendMessage}
      ></MessagingPopup>
    </React.Fragment>
  );
}
